$(window).on('resize', function () {
  var navWidth = $('.header-nav .main-navigation ul').width();
  if( $(window).width() > 1132 ){
    $( ".page-customer__infor" ).css( "maxWidth", 1132 + "px" );
  }else{
    $( ".page-customer__infor" ).css( "maxWidth", 100 + "%" );
  };
});

$(document).ready(function() {
  //Popup
  $('#newsletter-popup__form .sign_up').click(function(){
    var $form = $('#newsletter-popup__form');
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache       : false,
      dataType    : 'json',
      contentType: "application/json; charset=utf-8",
      error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
      success     : function(data) {
        setTimeout(function(){ 
          $(".button--close").trigger('click');

        }, 3000);
        if (data.result != "success") {
          var data = data.msg,
              newData = data.replace('1 -','').replace('0 -','');
          $("#newsletter-popup__form .response-text").show().removeClass("success").addClass("error").html(newData);  
          setTimeout(function(){ $("#newsletter-popup__form .response-text").hide(); }, 1000);

        } 
        else 
        {
          $(".mailchimp-form .response-text").show();
          $("#newsletter-popup__form .response-text").removeClass("error");
          $("#newsletter-popup__form .response-text").addClass("success");
          $("#newsletter-popup .response-text").html("Please check your email and confirm your subscription.");
          $('#newsletter-popup .newsletter').hide();
          var finalResponse = $(".response-final").text();
          $('#newsletter-popup .newsletter-popup-container p').html(finalResponse);
          setTimeout(function(){ $("#newsletter-popup .response-text").hide(); }, 1000);

        }
      }
    });
  });
  $( "#newsletter-popup__form" ).keypress(function(e) {
    if(e.which == 13) {
      $( "#newsletter-popup__form .sign_up" ).trigger( "click" );
      return false;
    }    
  });

  $(".button--close").click(function(){
    var date = new Date();
    date.setTime(date.getTime() + (3600 * 1000 * 24));
    $("#newsletter-popup").hide();
    $.cookie('hidebar', 'true', { expires: date });
  }); 
  var hidebar = $.cookie('hidebar');
  if (hidebar) {
    $("#newsletter-popup").hide();
  } else {
    $("#newsletter-popup").show();
  } 

  //End Popup




  
  
  


  $('body').css('opacity', '1');
  $('.article_sharing .social-sharing').stickUp({
    topMargin : '125px',
    keepInWrapper:!0,
    wrapperSelector: ".article_wrapper",
    disableOn : function(){
      if( $(window).width() < 841 )
        return false;
      return true;
    }
  });
  $('.product-related__slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.featured-products__slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.home-review_slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.home-brands_slider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,

        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          arrows: false,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  $('.site-header').stickUp();

  

  $('#mc-embedded-subscribe-form .ft_sign_up').click(function(){
    var $form = $('#mc-embedded-subscribe-form');
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache       : false,
      dataType    : 'json',
      contentType: "application/json; charset=utf-8",
      error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
      success     : function(data) {

        if (data.result != "success") {
          var data = data.msg,
              newData = data.replace('1 -','').replace('0 -','');
          $("#mc-embedded-subscribe-form .response-text").show().removeClass("success").addClass("error").html(newData);  
          setTimeout(function(){ $("#mc-embedded-subscribe-form .response-text").hide(); }, 5000);
        } 
        else 
        {
          $(".mailchimp-form .response-text").show();
          $("#mc-embedded-subscribe-form .response-text").removeClass("error");
          $("#mc-embedded-subscribe-form .response-text").addClass("success");
          $("#mc-embedded-subscribe-form .response-text").html("Please check your email and confirm your subscription.");
          $('#mc-embedded-subscribe-form .newsletter').hide(); 
          setTimeout(function(){ $("#mc-embedded-subscribe-form .response-text").hide(); }, 5000);

        }
      }
    });
  });
  $( "#mc-embedded-subscribe-form" ).keypress(function(e) {
    if(e.which == 13) {
      $( "#mc-embedded-subscribe-form .ft_sign_up" ).trigger( "click" );
      return false;
    }    
  });

});


